module.exports = {"632859100":"花土沟镇","632859101":"茫崖镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632859.json
// module id = 3166
// module chunks = 0